var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#181c1f",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m818.99 897.12v-594.8h-172.89v594.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.8 897.12v-594.8h-172.89v594.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1175.9 599.29c0 318.77-257.85 576.62-576.62 576.62-317.36 0-575.21-257.85-575.21-576.62 0-317.36 257.85-575.21 575.21-575.21 318.77 0 576.62 257.85 576.62 575.21zm-70.84 0c0 280.52-225.27 505.79-505.79 505.79-279.1 0-505.79-225.27-505.79-505.79 0-279.1 226.68-505.79 505.79-505.79 280.52 0 505.79 226.68 505.79 505.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.90414b93773c0fdf120c1a2dd9fe414b.svg";
export { ForwardRef as ReactComponent };